import { Injectable } from "@angular/core";
import { CommunicationService } from "../communication/communication.service";
import { InformComplementaireService } from "../inform-complementaire/inform-complementaire.service";
import { lotsService } from "../lots/lots.service";
import { NatureMarcheService } from "../nature-marche/nature-marche.service";
import { ProcedureService } from "../procedure/procedure.service";

@Injectable(
    {
        providedIn: 'root'
    })
export class FormfnsServices {

    constructor(public communicationService: CommunicationService, public informComplementaireService: InformComplementaireService,
        public lotsService: lotsService, public natureMarcheService: NatureMarcheService,
        public procedureService: ProcedureService) {
    }
}